import MainScreen from "../screens/MainScreen.vue";
import PrivacyPolicy from "../screens/privacy_policies/PrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyEN from "../screens/privacy_policies/diario_emocional/en/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyPT from "../screens/privacy_policies/diario_emocional/pt/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyES from "../screens/privacy_policies/diario_emocional/es/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyFR from "../screens/privacy_policies/diario_emocional/fr/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyIT from "../screens/privacy_policies/diario_emocional/it/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyNL from "../screens/privacy_policies/diario_emocional/nl/DiarioEmocionalPrivacyPolicy.vue";
import DiarioEmocionalPrivacyPolicyDE from "../screens/privacy_policies/diario_emocional/de/DiarioEmocionalPrivacyPolicy.vue";

import TruthOrDarePrivacyPolicyEN from "../screens/privacy_policies/truth_or_dare/en/TruthOrDarePrivacyPolice.vue";
import WhiteNoisePrivacyPolicyEN from "../screens/privacy_policies/white_noise/en/WhiteNoisePrivacyPolice.vue";
import LeituraBiblicaDiariaPrivacyPolicyPT from "../screens/privacy_policies/leitura_biblica_diaria/pt/LeituraBiblicaDiariaPrivacyPolicy.vue";

import TermsAndContitions from "../screens/terms_and_conditions/TermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsEN from "../screens/terms_and_conditions/diario_emocional/en/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsPT from "../screens/terms_and_conditions/diario_emocional/pt/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsES from "../screens/terms_and_conditions/diario_emocional/es/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsFR from "../screens/terms_and_conditions/diario_emocional/fr/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsIT from "../screens/terms_and_conditions/diario_emocional/it/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsNL from "../screens/terms_and_conditions/diario_emocional/nl/DiarioEmocionalTermsAndConditions.vue";
import DiarioEmocionalTermsAndContitionsDE from "../screens/terms_and_conditions/diario_emocional/de/DiarioEmocionalTermsAndConditions.vue";

import LeituraBiblicaDiariaTermsAndConditionsPT from "@/screens/terms_and_conditions/leitura_biblica_diaria/pt/LeituraBiblicaDiariaTermsAndConditionsPT.vue";
import LeituraBiblicaDiariaTermsAndConditionsEN from "@/screens/terms_and_conditions/leitura_biblica_diaria/en/LeituraBiblicaDiariaTermsAndConditionsEN.vue";

import DiarioDeEmocoesPrivacyPolicyPT from "@/screens/privacy_policies/diario_de_emocoes_com_senha/pt/DiarioDeEmocoesPrivacyPolicyPT.vue";

import SerenePrivacyPolicyPT from "@/screens/privacy_policies/serene/pt/SerenePrivacyPolicyPT.vue";
import SereneTermsAndConditionsPT from "@/screens/terms_and_conditions/serene/pt/SereneTermsAndConditionsPT.vue";
import SerenePrivacyPolicyES from "@/screens/privacy_policies/serene/es/SerenePrivacyPolicyES.vue";
import SereneTermsAndConditionsES from "@/screens/terms_and_conditions/serene/es/SereneTermsAndConditionsES.vue";
import SerenePrivacyPolicyEN from "@/screens/privacy_policies/serene/en/SerenePrivacyPolicyEN.vue";
import SereneTermsAndConditionsEN from "@/screens/terms_and_conditions/serene/en/SereneTermsAndConditionsEN.vue";

import HowToDeleteAccount from "../screens/how_to_delete_account/HowToDeleteAccount.vue";
import DiarioEmocionalHowToDeleteAccountEN from "../screens/how_to_delete_account/diario_emocional/en/DiarioEmocionalHowToDeleteAccountEN.vue";

import AppAdsTxtScreen from "../screens/app_ads_txt/AppAdsTxtScreen.vue";

const routes = [
    {
        path: '/',
        name: 'main',
        component: MainScreen,
    },
    {
        path: '/app-ads.txt',
        name: 'app_ads_txt',
        component: AppAdsTxtScreen,
    },
    {
        name: 'privacy_policy',
        path: '/privacy_policy/',
        component: PrivacyPolicy,
        children: [
            {
                path: 'en/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyEN,
            },
            {
                path: 'pt/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyPT,
            },
            {
                path: 'es/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyES,
            },
            {
                path: 'fr/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyFR,
            },
            {
                path: 'it/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyIT,
            },
            {
                path: 'nl/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyNL,
            },
            {
                path: 'de/diario_emocional',
                component: DiarioEmocionalPrivacyPolicyDE,
            },
            // 
            {
                path: 'en/truth_or_dare',
                component: TruthOrDarePrivacyPolicyEN,
            },
            //
            {
                path: 'en/white_noise',
                component: WhiteNoisePrivacyPolicyEN,
            },
            //
            {
                path: 'pt/devocional_diario_evangelico',
                component: LeituraBiblicaDiariaPrivacyPolicyPT,
            },
            //
            {
                path: 'pt/diario_de_emocoes_com_senha',
                component: DiarioDeEmocoesPrivacyPolicyPT,
            },
            {
                path: 'pt/serene',
                component: SerenePrivacyPolicyPT,
            },
            {
                path: 'en/serene',
                component: SerenePrivacyPolicyEN,
            },
            {
                path: 'es/serene',
                component: SerenePrivacyPolicyES,
            },
        ],
    },
    {
        name: 'terms_and_conditions',
        path: '/terms_and_conditions/',
        component: TermsAndContitions,
        children: [
            {
                path: 'en/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsEN,
            },
            {
                path: 'pt/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsPT,
            },
            {
                path: 'es/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsES,
            },
            {
                path: 'fr/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsFR,
            },
            {
                path: 'it/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsIT,
            },
            {
                path: 'nl/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsNL,
            },
            {
                path: 'de/diario_emocional',
                component: DiarioEmocionalTermsAndContitionsDE,
            },
            {
                path: 'pt/biblia_leitura_diaria',
                component: LeituraBiblicaDiariaTermsAndConditionsPT,
            },
            {
                path: 'en/biblia_leitura_diaria',
                component: LeituraBiblicaDiariaTermsAndConditionsEN,
            },
            {
                path: 'pt/serene',
                component: SereneTermsAndConditionsPT,
            },
            {
                path: 'en/serene',
                component: SereneTermsAndConditionsEN,
            },
            {
                path: 'es/serene',
                component: SereneTermsAndConditionsES,
            },
        ],
    },
    {
        name: 'how_to_delete',
        path: '/how_to_delete_account/',
        component: HowToDeleteAccount,
        children: [
            {
                path: 'en/diario_emocional',
                component: DiarioEmocionalHowToDeleteAccountEN,
            },
        ],
    },
];

export default routes;